"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHPreloadScene = void 0;
const KHContainer_1 = require("./KHContainer");
const WebFont = require("webfontloader");
class KHPreloadScene extends Phaser.Scene {
    constructor(key = "KHPreloadScene") {
        super(key);
        this.current_percent = 0;
    }
    preload() {
        this.cachedPalette = this.palette();
        this.game_width = Number(this.game.config.width);
        this.game_height = Number(this.game.config.height);
        const width = this.game_width / 2;
        const height = this.game_height / 5;
        this.loadBarContainer = new KHContainer_1.KHContainer(this, (this.game_width - width) / 2, (this.game_height - height) / 2, width, height, this.cachedPalette[1], 1, 0, false);
        this.add.existing(this.loadBarContainer);
        this.loadBar = this.add.graphics();
        this.loadBarContainer.add(this.loadBar);
        this.cameras.main.setBackgroundColor(this.cachedPalette[0]);
        this.load.on('progress', (value) => {
            this.setProgress(value);
        });
        this.loadAssets();
    }
    create() {
        this.setProgress(1);
        const fonts = this.fontsToLoad();
        if (fonts == null || fonts.length == 0) {
            this.startScene();
        }
        else {
            WebFont.load({
                custom: {
                    families: fonts
                },
                active: () => {
                    this.startScene();
                }
            });
        }
    }
    setProgress(percent) {
        percent = Math.max(this.current_percent, Math.min(percent, 1));
        const inset = this.loadBarContainer.c_h * .1;
        this.loadBar.clear();
        this.loadBar.fillStyle(this.cachedPalette[2]);
        const w = this.loadBarContainer.c_w - inset * 2, h = this.loadBarContainer.c_h - (inset * 2);
        this.loadBar.fillRect(inset, inset, Math.floor(percent * w), h);
        const logo = [
            [0, 0, 0, 0],
            [1, 1, 1, 1],
            [0, 0, 0, 1],
            [1, 1, 1, 1],
            [0, 1, 0, 1],
            [1, 0, 0, 1],
            [1, 1, 1, 1],
            [0, 0, 0, 0],
        ];
        this.drawBoxArray(this.loadBar, this.cachedPalette[1], logo, inset, inset, w, h);
    }
    drawBoxArray(graphics, col, arr, x, y, w, h) {
        const boxes_width = arr[0].length;
        const boxes_height = arr.length;
        const box_width = h / boxes_height;
        const all_width = box_width * boxes_width;
        const s_x = (w - all_width) / 2 + x;
        graphics.fillStyle(col);
        for (let i = 0; i < arr.length; i++) {
            for (let j = 0; j < arr[i].length; j++) {
                if (arr[i][j]) {
                    graphics.fillRect(s_x + box_width * j, y + box_width * i, box_width, box_width);
                }
            }
        }
    }
    startScene() {
        this.scene.start(this.nextScene(), null);
    }
    nextScene() {
        return "";
        // Override and return scene name.
    }
    loadAssets() {
        // Override and load assets.
    }
    fontsToLoad() {
        // Override and return font names, if any.
        return [];
    }
    /**
     * Color palette for the loading scene. [BG color, load bar color, logo color]
     */
    palette() {
        return [0x000000, 0x111111, 0x7d007e];
    }
}
exports.KHPreloadScene = KHPreloadScene;
